import { AuthWrapper, SignUpForm } from 'src/components';
import { Carousel } from '@common/components';
import { slides } from 'src/constants/slides';
import { useTranslation } from 'react-i18next';
import { useDocumentTitle } from '@mantine/hooks';

const SignUpPage = (): JSX.Element => {
  const [t] = useTranslation('auth');

  useDocumentTitle(t('signUpPageTitle'));
  return <AuthWrapper leftColumn={<Carousel slides={slides} />} rightColumn={<SignUpForm />} />;
};

export default SignUpPage;
